import React from 'react';
import pb from '../../lib/pocketbase';

function pbFileUrl(record, fileField, thumb) {
  try {
    if (!record || !record[fileField]) return '';
    return pb.files.getUrl(record, record[fileField], thumb ? { thumb } : undefined);
  } catch {
    return '';
  }
}

function stripHtml(input) {
  return String(input || '').replace(/<[^>]*>/g, '');
}

function HomeCmsSections() {
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    let mounted = true;
    const fetchSections = async () => {
      try {
        const res = await pb.collection('site_home_sections').getList(1, 100, {
          sort: 'sort_order, -created',
          filter: 'is_active = true',
        });
        const normalized = (res?.items ?? []).map((it) => {
          const img = pbFileUrl(it, 'image', '1600x0');
          return {
            id: it.id,
            key: it.key,
            title: it.title,
            contentHtml: it.content || '',
            contentText: stripHtml(it.content || ''),
            image: img,
          };
        });
        if (mounted) setItems(normalized);
      } catch {
        if (mounted) setItems([]);
      }
    };
    fetchSections();
    return () => { mounted = false; };
  }, []);

  if (!items.length) return null;

  return (
    <div>
      {items.map((s) => (
        <section key={s.id} style={{ marginTop: 26 }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: s.image ? 'minmax(0, 1fr) minmax(0, 1fr)' : 'minmax(0, 1fr)',
            gap: 18,
            alignItems: 'center'
          }}>
            <div>
              {s.title ? (<h2 style={{ marginTop: 0 }}>{s.title}</h2>) : null}
              {s.contentHtml ? (
                <div
                  style={{ color: 'var(--text-color, inherit)', lineHeight: 1.55 }}
                  dangerouslySetInnerHTML={{ __html: s.contentHtml }}
                />
              ) : null}
            </div>
            {s.image ? (
              <div>
                <img
                  src={s.image}
                  alt={s.title || ''}
                  style={{ width: '100%', height: 'auto', borderRadius: 14, display: 'block' }}
                  loading="lazy"
                />
              </div>
            ) : null}
          </div>
        </section>
      ))}
    </div>
  );
}

export default HomeCmsSections;
